/**
 * Web mirror of packages/types/src/buildManagement.ts.
 * CRA cannot transpile workspace TypeScript packages directly.
 * Keep in sync with @bilt/types buildManagement.
 */

export type BuildManagementSectionId =
  | 'profile'
  | 'performance'
  | 'contributors'
  | 'advanced';

export type BuildManagementSection = {
  id: BuildManagementSectionId;
  label: string;
  description: string;
  danger?: boolean;
};

export const BUILD_MANAGEMENT_ENTRY_LABEL = 'Manage build';

export const BUILD_MANAGEMENT_SECTIONS: BuildManagementSection[] = [
  {
    id: 'profile',
    label: 'Profile',
    description: 'Identity, specs, story, look, and build URL — edit inline.',
  },
  {
    id: 'performance',
    label: 'Performance',
    description: 'Dyno sheets, timed runs, and evidence.',
  },
  {
    id: 'contributors',
    label: 'Contributors',
    description: 'Credit shops and helpers on this build.',
  },
  {
    id: 'advanced',
    label: 'Advanced',
    description: 'Display defaults, export, and delete.',
    danger: true,
  },
];

export function isBuildManagementSectionId(value: string): value is BuildManagementSectionId {
  return BUILD_MANAGEMENT_SECTIONS.some((section) => section.id === value);
}
